import clsx from "clsx";

export const Separator: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({className, ...rest}) => {
  return <div className={clsx("w-full bg-stroke h-px", className)} {...rest} />;
};
